import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '@app/core/http';
import { DomainService } from '@app/shared/services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
})
export class PaymentResultComponent implements OnInit, OnDestroy {
  paymentResult: any | null = null;
  transactionInfo: any | null = null;
  durationInfo: any | null = null;
  durationResponse: any | null = null;
  domain: any | null = null;

  constructor(
    private generalService: GeneralService,
    public router: Router,
    private domainService: DomainService,
  ) {}

  ngOnInit() {
    const result = localStorage.getItem('payment-result') || '';
    const info = localStorage.getItem('transaction') || '';
    if (result) {
      this.paymentResult = JSON.parse(result) || {};
    }
    if (info) {
      this.transactionInfo = JSON.parse(info);
    }

    this.domain = this.domainService.get || {};
    if (this.paymentResult) {
      let trxId = this.paymentResult.referenceNo;

      // jeton vip
      if (this.paymentResult.original_reference_no) {
        trxId = this.paymentResult.original_reference_no;
      }

      // ex. jeton wallet
      if (this.paymentResult.id) {
        trxId = this.paymentResult.id;
      }

      // cepbank, dogecoin deposit etc.
      if (this.paymentResult.transactionId) {
        trxId = this.paymentResult.transactionId;
      }

      // get duration time interval for related transaction
      if (
        trxId &&
        this.paymentResult.status !== 'DECLINED' &&
        this.paymentResult.status !== 'ERROR'
      ) {
        this.generalService
          .getPaymentMethodDurationType({ transactionId: trxId })
          .pipe(untilDestroyed(this))
          .subscribe((response) => {
            this.durationResponse = response;
            if (response && response.durationType) {
              this.durationInfo = `${response.minTime} - ${
                response.maxTime
              } ${response.durationType.toLowerCase()}s`;
            }
          });
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  backToMerchant(status?: string) {
    if (this.domain?.domain === 'speedy.io') {
      this.generalService.backToMerchant(status, true);
    } else {
      this.generalService.backToMerchant(status);
    }
  }

  ngOnDestroy() {}
}
